import { ITankBatterySetupTemplate } from '../../interfaces/itank-battery-setup-template';
import { TankBatterySetupSize } from '../tank-battery-setup-size';

export class TankBatterySetupTemplateBase {
  TankBatterySetupTemplateId: number;
  TankBatterySetupSizeId: number;
  MaxGas: number;
  MaxOil: number;
  MaxWater: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  TankBatterySetupSize?: TankBatterySetupSize;

  constructor(item?: ITankBatterySetupTemplate) {
    if (item) {

      this.TankBatterySetupTemplateId = item.TankBatterySetupTemplateId;
      this.TankBatterySetupSizeId = item.TankBatterySetupSizeId;
      this.MaxGas = item.MaxGas;
      this.MaxOil = item.MaxOil;
      this.MaxWater = item.MaxWater;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.TankBatterySetupSize = new TankBatterySetupSize(item.TankBatterySetupSize);
    }
  }
}